import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';

const overlayBaseStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 20000, // Must be above sidebar (Sidebar.css uses 10001)
};

const modalStyle = {
  backgroundColor: '#0f0f0f',
  color: '#e0e0e0',
  padding: '18px',
  borderRadius: '10px',
  border: '1px solid #2a2a2a',
  width: '92vw',
  maxWidth: '560px',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.6)',
};

const actionBtnStyle = {
  background: 'transparent',
  border: '1px solid #2a2a2a',
  color: '#e0e0e0',
  borderRadius: '8px',
  padding: '10px 12px',
  cursor: 'pointer',
  fontWeight: 700,
};

const iconBtnStyle = {
  ...actionBtnStyle,
  padding: '8px 10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const primaryBtnStyle = {
  ...actionBtnStyle,
  background: 'var(--brand-accent-gradient)',
  border: 'none',
  color: '#fff',
};

export default function CreateRunGroupModal({ isOpen, onClose, onCreate, busy }) {
  const [name, setName] = useState('');
  const [notes, setNotes] = useState('');
  const [sidebarWidth, setSidebarWidth] = useState(0);

  useEffect(() => {
    if (!isOpen) return;

    const measure = () => {
      const el = document.querySelector('.sidebar');
      const w = el && el.getBoundingClientRect ? el.getBoundingClientRect().width : 0;
      setSidebarWidth(Number.isFinite(w) ? w : 0);
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [isOpen]);

  if (!isOpen) return null;

  const overlayStyle = {
    ...overlayBaseStyle,
    left: sidebarWidth ? `${sidebarWidth}px` : 0,
    width: sidebarWidth ? `calc(100% - ${sidebarWidth}px)` : '100%',
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
          <div style={{ fontSize: '18px', fontWeight: 800 }}>New Group</div>
          <button
            type="button"
            style={iconBtnStyle}
            onClick={onClose}
            disabled={!!busy}
            aria-label="Close"
            title="Close"
          >
            <FaTimes />
          </button>
        </div>

        <div style={{ marginTop: '12px' }}>
          <label style={{ display: 'block', fontSize: '13px', color: '#888', marginBottom: '6px' }}>
            Name
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Sunday session"
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '8px',
              border: '1px solid #2a2a2a',
              background: '#111',
              color: '#e0e0e0',
              outline: 'none',
            }}
            disabled={!!busy}
          />
        </div>

        <div style={{ marginTop: '12px' }}>
          <label style={{ display: 'block', fontSize: '13px', color: '#888', marginBottom: '6px' }}>
            Notes (optional)
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Optional notes…"
            rows={4}
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '8px',
              border: '1px solid #2a2a2a',
              background: '#111',
              color: '#e0e0e0',
              outline: 'none',
              resize: 'vertical',
            }}
            disabled={!!busy}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '14px' }}>
          <button
            type="button"
            style={actionBtnStyle}
            onClick={onClose}
            disabled={!!busy}
          >
            Cancel
          </button>
          <button
            type="button"
            style={primaryBtnStyle}
            disabled={!!busy || !name.trim()}
            onClick={async () => {
              const trimmed = name.trim();
              if (!trimmed) return;
              const ok = await onCreate?.({ name: trimmed, notes: notes.trim() || '' });
              if (ok !== false) {
                setName('');
                setNotes('');
                onClose?.();
              }
            }}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
}

